import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Timeline } from './timelines.model';
import { QueryResult, DocumentQueryParams } from '../../../core/store/models/query.model';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { Attachment } from 'src/app/modules/core/store/models/attachment.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class TimelineApiService {
  constructor(private http: HttpService) { }


  // Timeline
  public createTimeline(timelineDatasetUId: string, timeline: Timeline): Observable<Timeline[]> {
    const url = `${apiBaseUrl}/v1/data/datasets/${timelineDatasetUId}/documents`;

    const createRequest = {
      documents: [timeline]
    };

    return this.http.post<Timeline[]>(url, createRequest);
  }

  public updateTimeline(timelineDatasetUId: string, timeline: Timeline): Observable<Timeline[]> {
    const url = `${apiBaseUrl}/v1/data/datasets/${timelineDatasetUId}/documents`;

    const updateRequest = {
      documents: [timeline]
    };

    return this.http.put<Timeline[]>(url, updateRequest);
  }

  public deleteTimeline(datasetUId: string, timeline: Timeline): Observable<void> {
    const reader = new DocumentReader(timeline);

    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/documents/${reader.uId}`;

    return this.http.delete(url);
  }

  public getTimelines(incidentDatasetUId: string, incidentUId: string, timelineDatasetUId: string, query: DocumentQueryParams): Observable<QueryResult<Timeline>> {
    const queryString = this.http.queryStringFromObject({ includeCount: true });

    const url = `${apiBaseUrl}/v1/data/datasets/${incidentDatasetUId}/documents/${incidentUId}/children/${timelineDatasetUId}/query?${queryString}`;

    return this.http.post(url, query);
  }

  public getTimelineAttachments(datasetUId: string, timelineUId: string): Observable<QueryResult<Attachment>> {

    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/files/${timelineUId}?skip=0&take=1000&sortField=UpdatedOn&sortDirection=Ascending`;

    return this.http.get<QueryResult<Attachment>>(url);
  }

  public getUrlMetata(siteUrl: string): Observable<any> {

    const url = `${apiBaseUrl}/v1/data/Utility/siteinfo/${encodeURIComponent(siteUrl)}`;

    return this.http.get<any>(url);
  }
}
